import "../../../App.scss";
import "antd/dist/reset.css"; // dùng cho antd v5
import { useState } from "react";
import Products from "./Products";
import { useAuth } from "../../context/AuthContext";
import AdminSocketNewOrder from "../../../infrastructure/socket/AdminSocketNewOrder";
import Visible from "../../components/Visible";
import Header from "./Header";

function MainUserPage() {
  const [activeMenuNav, setActiveMenuNav] = useState<number>(1);
  const [filterProduct, setFilterProduct] = useState<string>("");
  const [selectedSectionId, setSelectedSectionId] = useState<string>();

  const { authData } = useAuth();

  return (
    <div className="app-wrapper">
      <Visible isVisible={!authData?.use_admin_site}>
        <Header
          activeMenuNav={activeMenuNav}
          setActiveMenuNav={setActiveMenuNav}
          setFilterProduct={setFilterProduct}
           filterProduct={filterProduct}
          selectedSectionId={selectedSectionId}
          setSelectedSectionId={setSelectedSectionId}
        />

        <div
          className="content-scrollable"
          style={{ overflowY: "auto" }}
          id="content_scrollable_app_element"
        >
          <Products
            activeMenuNav={activeMenuNav}
            setActiveMenuNav={setActiveMenuNav}
            filterProduct={filterProduct}
            setFilterProduct={setFilterProduct}
            selectedSectionId={selectedSectionId}
            setSelectedSectionId={setSelectedSectionId}
          />
        </div>
      </Visible>
      <Visible isVisible={!!authData?.id}>
        <AdminSocketNewOrder />
      </Visible>
    </div>
  );
}

export default MainUserPage;
